import { Navigate, Route, Routes } from 'react-router-dom';

import MesesSinIntereses from '../msi/MesesSinIntereses.jsx';
import Prestamos from '../prestamos/Prestamos.jsx';
import Vencimientos from '../vencimientos/Vencimientos.jsx';
import DesactivarCuenta from './pantallas/DesactivarCuenta.jsx';
import DetalleDeCuenta from './pantallas/DetalleDeCuenta.jsx';
import EditarCuenta from './pantallas/EditarCuenta.jsx';
import ListaDeCuentas from './pantallas/ListaDeCuentas.jsx';
import ListaDeTarjetas from './pantallas/ListaDeTarjetas.jsx';
import RenovarTarjeta from './pantallas/RenovarTarjeta.jsx';

/**
 * Destino "Cuentas" del incremento 2/6 (RF-042).
 *
 * El módulo se enchufa al shell con la sección que el núcleo ya registra —clave
 * `cuentas`, ruta `/cuentas`, etiqueta corta "Cuentas"— y aquí resuelve sus
 * propias rutas internas. Cuentas y Tarjetas son DOS PESTAÑAS DE UN MISMO DESTINO:
 * el módulo no reclama un segundo lugar en la barra y no desplaza a Ajustes
 * (RN-044b, RN-044c).
 */
export default function CuentasYTarjetas() {
  return (
    <Routes>
      <Route index element={<ListaDeCuentas />} />
      <Route path="tarjetas" element={<ListaDeTarjetas />} />
      {/* TERCERA PESTAÑA: el incremento 4/6 (RF-077, D-62). No registra sección de
          navegación propia y no desplaza a nadie al menú secundario. */}
      <Route path="meses/*" element={<MesesSinIntereses />} />
      {/* CUARTA PESTAÑA: el incremento 6/6 (RF-122, D-185). Tampoco registra sección
          de navegación propia y tampoco desplaza a nadie: el panel de vencimientos
          vive dentro de este destino, igual que los meses sin intereses. */}
      <Route path="vencimientos/*" element={<Vencimientos base="/cuentas/vencimientos" />} />
      {/* INCREMENTO 20/21 · Préstamos: alta y pagos (RF-264 a RF-271, D-434). Un
          préstamo ES una cuenta —de tipo Préstamo—, así que sus pantallas cuelgan de
          este mismo destino y el módulo NO registra sección de navegación propia ni
          desplaza a nadie, igual que el 4/6 y el 6/6. Va ANTES de `:idCuenta` para
          que «prestamos» no se lea como un identificador de cuenta. */}
      <Route path="prestamos/*" element={<Prestamos />} />
      <Route path="nueva" element={<EditarCuenta />} />
      <Route path=":idCuenta" element={<DetalleDeCuenta />} />
      <Route path=":idCuenta/editar" element={<EditarCuenta />} />
      {/* La renovación no existe en Efectivo: la pantalla lo dice y el servidor lo
          rechaza con RENOVACION_NO_APLICA (D-28, RN-070g). */}
      <Route path=":idCuenta/renovacion" element={<RenovarTarjeta />} />
      <Route path=":idCuenta/desactivar" element={<DesactivarCuenta />} />
      <Route path="*" element={<Navigate to="/cuentas" replace />} />
    </Routes>
  );
}
